// @flow
import React from "react";
import cx from "classnames";
import type { Tab } from "../../Tabs";

import styles from "./Title.scss";

type TitleProps = {
  tab: Tab,
  tabIndex: number,
  activeIndex: number,
  changeActiveIndex: (index: number) => void
};

const Title = ({
  tab: { title, amount },
  tabIndex,
  activeIndex,
  changeActiveIndex
}: TitleProps) => {
  const content = title();
  const isActive = tabIndex === activeIndex;

  return (
    <button
      type="button"
      className={cx(styles.title, {
        [styles.activeTitle]: isActive
      })}
      onClick={() => changeActiveIndex(tabIndex)}
      data-isactive={isActive}
      // eslint-disable-next-line react/no-array-index-key
      title={content}
    >
      {(amount || amount === 0) && <div className={styles.amountInTitle}>{amount}</div>}
      {content}
    </button>
  );
};

export default Title;
